const initialState = {
    data: [],
  };
  
  const mieszkancyReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MIESZKANCY':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default mieszkancyReducer;